// Curated, human-readable labels for tool names whose title-cased form reads
// poorly (acronyms, internal suffixes). Anything not listed falls back to
// title-casing the snake_case name, e.g. `generate_python_code` →
// "Generate Python Code".
const TOOL_DISPLAY_NAMES: Record<string, string> = {
  python_analyzer: "Python Analyzer",
  data_retriever: "Data Retriever",
  biomcp_fda: "BioMCP FDA",
  get_dataset_metadata: "Get Dataset Metadata",
  execute_sql: "Execute SQL",
  execute_sql_to_text: "Execute SQL",
  execute_sql_to_dataframe: "Execute SQL",
  discover_dataset_files: "Discover Files",
  retrieve_dataset_file: "Get File",
  final_result: "Final Result",
  pipeline_submit_run: "Submit Pipeline Run",
  pipeline_cancel_run: "Cancel Pipeline Run",
  pipeline_get_run_status: "Check Run Status",
  pipeline_list_workflows: "List Workflows",
  pipeline_get_run_outputs: "Get Run Outputs",
};

export function toolDisplayName(toolName: string): string {
  return (
    TOOL_DISPLAY_NAMES[toolName] ??
    toolName.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
  );
}
